import { MultiplierAct } from "./MultiplierAct";

/**
 * @description Fix for free spins multiplier win counter (undercount of cumulative total).
 * onearm анимирует счётчик к абсолютному result.win.total (выигрыш только этого спина),
 * из-за чего во фри-спинах в покое оседает выигрыш одного спина вместо кумулятива.
 * Смещаем baseline и цель счётчика на кумулятив, накопленный ДО текущего спина.
 */
export class FreeSpinsMultiplierAct extends MultiplierAct {
    constructor(params) {
        super(params);

        // getFreeSpinsTotalWin() уже включает тотал текущего спина — вычитаем его,
        // получая кумулятив по предыдущим фри-спинам.
        this._offset = this.gameLogic.getFreeSpinsTotalWin() - this.result.win.total;

        // Прямое присваивание _win (НЕ сеттер): акты конструируются заранее, сеттер дёрнул бы
        // hud.setWin в момент конструирования. Стыкуется с концом FreeSpinsPaysAct.
        this._win = this._offset + this.result.win.beforeMultiplier;
    }

    getWinCounterTimeline(targetWin) {
        return super.getWinCounterTimeline(this._offset + targetWin);
    }

    skip() {
        this.hud.setWin(this._offset + this.result.win.total);
        this.finalizeTumbleWin(this.result.win.total);
        this.reelsScene.goToIdle();
    }
}
